import React from 'react';
import { t } from '../../../utils/textUtils';
import {
  Box,
  Grid,
  TextField,
  Typography,
  MenuItem,
  Paper,
  Stack,
  Divider
} from '@mui/material';
// import LocationOnIcon from '@mui/icons-material/LocationOn'; // Tidak digunakan
// import CodeIcon from '@mui/icons-material/Code'; // Tidak digunakan
// import CategoryIcon from '@mui/icons-material/Category'; // Tidak digunakan
// import BusinessIcon from '@mui/icons-material/Business'; // Tidak digunakan
import DescriptionIcon from '@mui/icons-material/Description';
// import MapIcon from '@mui/icons-material/Map'; // Tidak digunakan

const jenisProyekOptions = [
  'MODULAR HOUSING',
  'GUDANG',
  'KANTOR PREFAB',
  'SEKOLAH PREFAB',
  'KLINIK/FASILITAS KESEHATAN',
  'POS JAGA/SECURITY',
  'TOILET PREFAB',
  'CONTAINER MODIFICATION',
  'LAINNYA'
];

const sektorOptions = [
  'OIL AND GAS',
  'PLANTATION',
  'MINING'
];

const GeneralInfoForm = ({ formData, onChange, errors = {} }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
  };

  const SectionHeader = ({ title, description, icon }) => (
    <Paper
      variant="outlined"
      sx={{
        p: 2.5,
        mb: 2.5,
        borderRadius: 2,
        borderColor: 'divider',
        bgcolor: '#F8FAFC'
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: 2,
            bgcolor: '#ffffff',
            boxShadow: '0 8px 20px rgba(15, 23, 42, 0.08)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {icon}
        </Box>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </Box>
      </Stack>
    </Paper>
  );

  return (
    <Box>
      <SectionHeader
        title={t('INFORMASI UMUM PROYEK')}
        description={t('Masukkan informasi dasar tentang proyek konstruksi prefabrikasi yang akan dibuat.')}
        icon={<DescriptionIcon sx={{ color: '#4F46E5' }} />}
      />

      <Paper 
        elevation={0}
        sx={{ 
          p: { xs: 2, sm: 3 }, 
          borderRadius: 2, 
          border: '1px solid',
          borderColor: 'rgba(15, 23, 42, 0.1)',
          bgcolor: '#FFFFFF',
          boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)'
        }}
      >
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1e40af', mb: 0.5 }}>
            {t('IDENTITAS PROYEK')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t('Gunakan nama dan kode yang mudah dicari di laporan.')}
          </Typography>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              label={t('NAMA PROYEK (LEVEL 1) *')}
              name="name"
              value={formData.name || ''}
              onChange={handleChange}
              error={!!errors.name}
              helperText={errors.name ? t(errors.name.toUpperCase()) : t('Contoh: Proyek Perumahan Modular Cikarang 2')}
              placeholder={t('CONTOH: PROYEK PERUMAHAN MODULAR CIKARANG 2')}
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: '#3B82F6'
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#3B82F6'
                  }
                }
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={t('NO PO')}
              name="noPO"
              value={formData.noPO || ''}
              onChange={handleChange}
              placeholder={t('KC002')}
              variant="outlined"
              helperText={t('Nomor purchase order atau no kontrak (opsional)')}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: '#3B82F6'
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#3B82F6'
                  }
                }
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={t('KODE PROYEK')}
              name="kodeProyek"
              value={formData.kodeProyek || formData.projectCode || ''}
              onChange={handleChange}
              error={!!errors.kodeProyek}
              helperText={errors.kodeProyek ? t(errors.kodeProyek.toUpperCase()) : t('Kode identifikasi unik untuk proyek (opsional)')}
              variant="outlined"
              placeholder={t('MASUKKAN KODE IDENTIFIKASI PROYEK')}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: '#3B82F6'
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#3B82F6'
                  }
                }
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              select
              label={t('JENIS PROYEK *')}
              name="jenisProyek"
              value={formData.jenisProyek || ''}
              onChange={handleChange}
              error={!!errors.jenisProyek}
              helperText={errors.jenisProyek ? t(errors.jenisProyek.toUpperCase()) : t('Pilih jenis proyek prefabrikasi')}
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: '#3B82F6'
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#3B82F6'
                  }
                }
              }}
            >
              {jenisProyekOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {t(option)}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              select
              label={t('SEKTOR *')}
              name="sektor"
              value={formData.sektor || ''}
              onChange={handleChange}
              error={!!errors.sektor}
              helperText={errors.sektor ? t(errors.sektor.toUpperCase()) : t('Pilih sektor industri proyek')}
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: '#3B82F6'
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#3B82F6'
                  }
                }
              }}
            >
              {sektorOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {t(option)}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(15, 23, 42, 0.1)' }} />

        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1e40af', mb: 0.5 }}>
            {t('LOKASI & KOORDINAT')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t('Lengkapi alamat proyek dan koordinat GPS jika tersedia.')}
          </Typography>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              label={t('LOKASI PROYEK *')}
              name="location"
              value={formData.location || ''}
              onChange={handleChange}
              error={!!errors.location}
              helperText={errors.location ? t(errors.location.toUpperCase()) : t('Alamat lengkap lokasi proyek')}
              placeholder={t('JL. INDUSTRI CIKARANG')}
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: '#3B82F6'
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#3B82F6'
                  }
                }
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={t('LATITUDE (LINTANG)')}
              name="latitude"
              value={formData.latitude || ''}
              onChange={handleChange}
              error={!!errors.latitude}
              helperText={errors.latitude ? t(errors.latitude.toUpperCase()) : t('Contoh: -6.2088 (gunakan titik, bukan koma)')}
              placeholder={t('-6.2088')}
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: '#3B82F6'
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#3B82F6'
                  }
                }
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={t('LONGITUDE (BUJUR)')}
              name="longitude"
              value={formData.longitude || ''}
              onChange={handleChange}
              error={!!errors.longitude}
              helperText={errors.longitude ? t(errors.longitude.toUpperCase()) : t('Contoh: 106.8456 (gunakan titik, bukan koma)')}
              placeholder={t('106.8456')}
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: '#3B82F6'
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#3B82F6'
                  }
                }
              }}
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(15, 23, 42, 0.1)' }} />

        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1e40af', mb: 0.5 }}>
            {t('DESKRIPSI PROYEK')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t('Tuliskan tujuan dan kebutuhan khusus proyek.')}
          </Typography>
        </Box>

        <TextField
          fullWidth
          label={t('DESKRIPSI SINGKAT')}
          name="description"
          value={formData.description || ''}
          onChange={handleChange}
          placeholder={t('DESKRIPSI SINGKAT TENTANG PROYEK, TUJUAN, DAN KEBUTUHAN KHUSUS')}
          multiline
          rows={4}
          variant="outlined"
          helperText={t('Jelaskan secara singkat tentang proyek, tujuan, dan kebutuhan khusus')}
          sx={{
            '& .MuiOutlinedInput-root': {
              '&:hover fieldset': {
                borderColor: '#3B82F6'
              },
              '&.Mui-focused fieldset': {
                borderColor: '#3B82F6'
              }
            }
          }}
        />
      </Paper>
    </Box>
  );
};

export default GeneralInfoForm;
